/**
 * In-memory Strapi GET cache for the SPA session.
 * Successful responses are reused; in-flight requests are deduped;
 * failed requests are cleared so a later call can retry.
 */
const cache = new Map();

export function cachedGet(client, url) {
  if (cache.has(url)) {
    return cache.get(url);
  }

  const request = client.get(url).catch((error) => {
    cache.delete(url);
    throw error;
  });

  cache.set(url, request);
  return request;
}

/** Test helper — clears the session cache. */
export function clearStrapiCache() {
  cache.clear();
}
